import colors from 'styles/colors'

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column'
  },
  carousel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 26,
    marginTop: 16,
    marginBottom: 21
  },
  dayCarousel: {
    marginTop: 20,
    marginBottom: 0
  },
  slider: {
    flex: 1,
    height: 50,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  daySlider: {
    justifyContent: 'initial'
  },
  button: {
    background: 'none',
    border: 'none'
  },
  monthYear: {
    color: colors.primary,
    fontFamily: 'Barlow',
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '1.17px',
    lineHeight: '18px',
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  dayContainer: {
    cursor: 'pointer',
    border: 'none',
    pointerEvents: 'auto'
  },
  dayOfWeek: {
    fontFamily: 'Barlow',
    fontSize: 13.5,
    fontWeight: 'bold',
    letterSpacing: '0.45px',
    lineHeight: '19px',
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  day: {
    fontFamily: 'Barlow',
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  noAvailableTimeslotText: {
    fontFamily: 'Barlow',
    fontSize: 16,
    textAlign: 'center'
  },
  timeslotsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '320px',
    gap: '19px 38.5px',
    marginTop: '32px',
    marginBottom: '43px',
    alignSelf: 'center',
    justifyContent: 'center'
  }
}

styles.dayOfWeekSelected = { ...styles.dayOfWeek, color: colors.primary }
styles.dayOfWeekNotSelected = { ...styles.dayOfWeek, color: colors.olderGray }

styles.daySelected = { ...styles.day, color: colors.primary }
styles.dayNotSelected = { ...styles.day, color: colors.olderGray }

export default styles
